import React from "react";
import { Link, useNavigate } from "react-router-dom";
import FormInput from "src/components/widgets/FormInput";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { forgotPassword } from "src/api/auth";
import { showSuccessToast } from "src/lib/utils";

const initialValues = {
	email: "",
};
const validationSchema = Yup.object().shape({
	email: Yup.string().email("Invalid email address").required("Email is required"),
});

const ForgotPassword = () => {
	const navigate = useNavigate();

	const { mutate, isLoading } = useMutation(forgotPassword, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			navigate("/reset-password");
		},
	});

	return (
		<div className="loginForm tw-px-6 md:tw-px-10 tw-py-8">
			<div className="pageTitle">
				<h1>Forgot Password</h1>
				<p>Setup a new and secure password.</p>
			</div>

			<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
				{({ values, handleChange, handleSubmit, errors }) => (
					<form onSubmit={handleSubmit}>
						<FormInput
							label="Email"
							name="email"
							type="email"
							placeholder="Email"
							value={values.email}
							onChange={handleChange}
							error={errors.email}
							autoComplete="off"
						/>

						<button type="submit" className="authButton" disabled={isLoading}>
							{isLoading ? "Loading..." : "Continue"}
						</button>

						<p className="authFormText">
							<Link to="/login">Click here to Login</Link>
						</p>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default ForgotPassword;
